import { Component } from '@angular/core';
import { OrderModel } from 'models/generated/Entities.GormCrm.Order';
import { Layout } from 'modules/layout';
import { TranslatePipe } from 'pipes/translate.pipe';
import { ComponentUrl } from 'services/navigation.service';
import { SalesService } from 'services/sales.service';
import { UserService } from 'services/user.service';
import { ListOrdersComponent } from './list-orders.component';

@Component({
	selector: 'my-order',
	templateUrl: './my-orders.component.html',
	imports: [Layout, ListOrdersComponent, TranslatePipe]
})
@ComponentUrl('my-orders')
export class MyOrdersComponent {
	constructor(public readonly userService: UserService, private readonly salesService: SalesService, private readonly translate: TranslatePipe) { }

	orderCompletedStatus = (order: OrderModel) => {
		const status = this.salesService.getOrderStatus(order);

		if (status === 'approved' || status == 'cancelled') return this.translate.transform('sale.order-completed-status.completed');
		else return this.translate.transform('sale.order-completed-status.pending');
	};
}
